// @ts-strict-ignore
import React, { useContext } from 'react';
import { RuleBuilderContext } from '../context';
import MatrixModel, { ReadOnlyMatrixModel } from '../../../MatrixModel';
import { StyledMatrixModelContainer } from './styles';
import { isEditable } from '../helpers';

export default function MatrixModelContainer() {
  const { editMode, sourceAction } = useContext(RuleBuilderContext);

  return (
    <StyledMatrixModelContainer>
      {
        isEditable(editMode)
          ? <MatrixModel action={sourceAction} />
          : <ReadOnlyMatrixModel matrixModel={sourceAction.matrixModel} />
      }
    </StyledMatrixModelContainer>
  );
}
